<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست سطح دوره ها</h1>
          <b-col cols="12" md="5">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-group
                class="d-inline-block w-100"
                label="جستجو کنید"
                label-for="questionLevel"
              >
                <b-form-input
                  v-model="searchCommand"
                  class="d-inline-block"
                  placeholder="جستجو..."
                  @keydown.enter="getAllCourseTypes"
                />
              </b-form-group>
              <b-button
                variant="primary"
                class="ml-1"
                @click="getAllCourseTypes"
              >
                اعمال
              </b-button>
            </div>
          </b-col>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="courseTypes"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(isDescriptive)="data">
              {{ data.item.correctLongAnswer ? "تشریحی" : "چهار گزینه‌ای" }}
            </template>
            <template #cell(createDate)="data">
              {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(Edit)="data">
              <!-- <div
                style="cursor: pointer"
                @click="renderEditModal(data.item)"
                v-b-modal.modal-edit
              > -->
              <b-link :to="`/courses/course-type/${data.item.courseTypeId}`">
                <feather-icon class="text-primary" icon="EditIcon" size="20" />
              </b-link>
              <!-- </div> -->
            </template>
            <template #cell(Delete)="data">
              <div
                style="cursor: pointer"
                @click="renderDeleteConfirmation(data.item.courseTypeId)"
                v-b-modal.modal-delete
              >
                <feather-icon class="text-danger" icon="Trash2Icon" size="20" />
              </div>
            </template>
          </b-table>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="حذف سطح دوره"
      id="modal-delete"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteACourseType"
    >
      <span>آیا از حذف کردن این سطح دوره اطمینان دارید ؟ </span>
    </b-modal>
    <!-- <b-modal
      title="ویرایش سطح دوره"
      id="modal-edit"
      centered
      ok-title="ویرایش"
      cancelTitle="بستن"
      @ok="updateACourseType"
    >
      <b-form class="p-2" @submit.prevent v-if="tempCourseTypeObject">
        <b-form-group label="عنوان سطح دوره" label-for="course-type-title">
          <b-form-input
            id="course-type-title"
            v-model="tempCourseTypeObject.title"
            trim
            placeholder="ابتدایی"
          />
        </b-form-group>
      </b-form>
    </b-modal> -->
  </b-overlay>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import {
  GetCourseTypes,
  DeleteACourseType,
  UpdateACourseType,
} from "../../../../libs/Api/CourseType";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  mounted() {
    this.getAllCourseTypes();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllCourses();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      courseTypes: null,
      tempCourseTypeId: null,
      tempCourseTypeObject: null,
      searchCommand: null,
      myTableColumns: [
        {
          key: "courseTypeId",
          label: "شناسه سطح",
        },
        {
          key: "title",
          label: "عنوان سطح",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت",
        },
        {
          key: "Edit",
          label: "ویرایش",
        },
        {
          key: "Delete",
          label: "حذف",
        },
      ],
    };
  },
  methods: {
    async updateACourseType() {
      let _this = this;
      let updateACourseType = new UpdateACourseType(_this);
      updateACourseType.setRequestParamDataObj(_this.tempCourseTypeObject);
      await updateACourseType.fetch(
        function (response) {
          _this.getAllCourseTypes();
          _this.tempCourseTypeObject = null;
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "ویرایش با موفقیت انجام شد",
              icon: "EditIcon",
              variant: "success",
            },
          });
        },
        function (error) {
          console.error(error);
        }
      );
    },
    renderEditModal(courseType) {
      this.tempCourseTypeObject = JSON.parse(JSON.stringify(courseType));
    },
    async deleteACourseType() {
      let _this = this;
      let deleteACourseType = new DeleteACourseType(_this);
      deleteACourseType.setRequestParam({
        id: _this.tempCourseTypeId,
      });
      await deleteACourseType.fetch(
        function (response) {
          _this.getAllCourseTypes();
          _this.tempCourseTypeId = null;
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "حذف با موفقیت انجام شد",
              icon: "Trash2Icon",
              variant: "success",
            },
          });
        },
        function (error) {
          console.error(error);
        }
      );
    },
    renderDeleteConfirmation(courseTypeId) {
      this.tempCourseTypeId = courseTypeId;
    },
    async getAllCourseTypes() {
      this.isLoading = true;
      let _this = this;
      let getCourseTypes = new GetCourseTypes(_this);
      let qParams = {
        count: _this.count,
        pageNumber: _this.pageNumber,
      };
      if (this.searchCommand) {
        qParams["searchCommand"] = this.searchCommand;
      }
      getCourseTypes.setParams(qParams);
      await getCourseTypes.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.courseTypes = response.data.courseTypes;
            _this.totalCount = response.data.courseTypesCount;
          }
        },
        function (error) {
          console.error(error);
        }
      );
      this.isLoading = false;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BModal,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
